import suspendedAccess from '../../assets/images/suspended-access.svg';
import './_access-suspended.scss';

const AccessSuspended = () => {
  return (
    <main className="access-suspended" role="main">
      <section className="access-suspended__card" aria-labelledby="access-suspended-title">
        <img className="access-suspended__illustration" src={suspendedAccess} alt="" aria-hidden="true" />
        <div className="access-suspended__content">
          <h1 id="access-suspended-title">Portal Access Temporarily Suspended</h1>
          <div className="access-suspended__description">
            <p>Your access has been temporarily suspended. For more details</p>
            <p>contact your HR.</p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default AccessSuspended;
